module.exports = (__webpack_require__(2796))(961);